import ApiApplicationView from "./ApiApplicationView";

export default ApiApplicationView;
